import model from '~/assets/js/model';

export default model({
  phone: null,
  password: '',
});
